
<template>

<el-tabs v-model="activeName" type="card">

    <el-tab-pane label="内网商家" name="second" :lazy="false">
        <joined-intranet-business></joined-intranet-business>
    </el-tab-pane>
    <el-tab-pane label="待审核" name="first" :lazy="true">
        <apply-intranet-business></apply-intranet-business>
    </el-tab-pane>
  <!--  <el-tab-pane label="仅注册" name="third" :lazy="false">
        <register-intranet-business></register-intranet-business>
    </el-tab-pane>-->

</el-tabs>

</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import applyIntranetBusiness from './applyIntranetBusiness'
import JoinedIntranetBusiness from '@/pages/plusbusiness/joinedIntranetBusiness'
import registerIntranetBusiness from '@/pages/plusbusiness/registerIntranetBusiness'
export default {
  name: 'plus-intranet-business-tab-index',
  extends: BasicPager,
  components: {
    JoinedIntranetBusiness,
    applyIntranetBusiness,
    registerIntranetBusiness
  },
  data () {
    return {
      activeName: 'second'
    }
  },
  created () {
    let params = this.$route.params
    if (params.activeName) {
      this.activeName = params.activeName
    }
  }
}

</script>
